import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_mst_shipping_price_book_event_RowClass } from '../../../dbschema';

export class ShippingPriceBookEventContainerModel extends BaseContainerModel {
  bl_fi_mst_shipping_price_book_event: bl_fi_mst_shipping_price_book_event_RowClass = new bl_fi_mst_shipping_price_book_event_RowClass();
}
